"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var localStorageUtils_1 = require("../../app/utils/localStorageUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.isLoading = ko.observable(true);
        this.widgetHtml = ko.observable();
        var recentlyViewedWorkIds = localStorageUtils_1.default.get(localStorageUtils_1.default.RecentlyViewedKey);
        var showCarousel = recentlyViewedWorkIds && recentlyViewedWorkIds.length > 0;
        ajaxUtils_1.AjaxUtils.get("work/getByIds", { workIds: recentlyViewedWorkIds })
            .done(function (result) {
            if (!result.isSuccessful) {
                alert(result.messages[0]);
                return;
            }
            $("#recentlyViewed").html(result.data.html);
            if (showCarousel) {
                app.f7.swiper(".work-slider", {
                    slidesPerView: "auto",
                    speed: 300,
                    spaceBetween: 8,
                    slidesPerGroup: 3,
                    grabCursor: true,
                    scrollbar: ".swiper-scrollbar"
                });
            }
        }).always(function () {
            _this.isLoading(false);
        });
    }
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=homeLibrary.js.map